/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import * as ArchivesAPI from 'ArchivesAPI';
import { filterUserResourcesToObject } from 'Utils';

export const GET_ARCHIVED_DATA = 'GET_ARCHIVED_DATA';
export const GET_ARCHIVED_DATA_FAILURE = 'GET_ARCHIVED_DATA_FAILURE';
export const GET_ARCHIVED_DATA_SUCCESS = 'GET_ARCHIVED_DATA_SUCCESS';

export const ARCHIVE_HIERARCHY_ITEM = 'ARCHIVE_HIERARCHY_ITEM';
export const ARCHIVE_HIERARCHY_ITEM_FAILURE = 'ARCHIVE_HIERARCHY_ITEM_FAILURE';
export const ARCHIVE_HIERARCHY_ITEM_SUCCESS = 'ARCHIVE_HIERARCHY_ITEM_SUCCESS';

export const RESTORE_HIERARCHY_ITEM = 'RESTORE_HIERARCHY_ITEM';
export const RESTORE_HIERARCHY_ITEM_FAILURE = 'RESTORE_HIERARCHY_ITEM_FAILURE';
export const RESTORE_HIERARCHY_ITEM_SUCCESS = 'RESTORE_HIERARCHY_ITEM_SUCCESS';

export const DELETE_HIERARCHY_ITEM = 'DELETE_HIERARCHY_ITEM';
export const DELETE_HIERARCHY_ITEM_FAILURE = 'DELETE_HIERARCHY_ITEM_FAILURE';
export const DELETE_HIERARCHY_ITEM_SUCCESS = 'DELETE_HIERARCHY_ITEM_SUCCESS';

// ---------------------------------------------------
// fetch archived resource data ----------------------
// ---------------------------------------------------
// action
const getArchivedHierarchyItemsData = () => ({
  type: GET_ARCHIVED_DATA,
});

// action
const getArchivedHierarchyItemsDataFailure = error => ({
  type: GET_ARCHIVED_DATA_FAILURE,
  payload: error,
});

// action
const getArchivedHierarchyItemsDataSuccess = storeData => ({
  type: GET_ARCHIVED_DATA_SUCCESS,
  payload: storeData,
});

export const fetchArchivedHierarchyItemsData =
  () =>
  (dispatch, getState, { dataCache }) => {
    dispatch(getArchivedHierarchyItemsData());
    return ArchivesAPI.getArchivedHierarchyItems()
      .then(responseJson => filterUserResourcesToObject(responseJson, dataCache))
      .then(responseJson => {
        dispatch(getArchivedHierarchyItemsDataSuccess(responseJson || ''));
        return responseJson;
      })
      .catch(error => {
        dispatch(getArchivedHierarchyItemsDataFailure(error));
      });
  };

// -----------------------------------------
// Archive resource actions
// -----------------------------------------
const startArchiveHierarchyItem = () => ({
  type: ARCHIVE_HIERARCHY_ITEM,
});

const archiveHierarchyItemFailure = error => ({
  type: ARCHIVE_HIERARCHY_ITEM_FAILURE,
  payload: error,
});

const archiveHierarchyItemSuccess = hierarchyPath => ({
  type: ARCHIVE_HIERARCHY_ITEM_SUCCESS,
  payload: hierarchyPath,
});

export const archiveHierarchyItem =
  hierarchyPath =>
  (dispatch, getState, { dataCache }) => {
    dispatch(startArchiveHierarchyItem());
    const userEmailId = dataCache.get('currentUser')?.id;

    return ArchivesAPI.archiveHierarchyItem(hierarchyPath, userEmailId)
      .then(responseJson => {
        dispatch(archiveHierarchyItemSuccess(hierarchyPath));
        return responseJson;
      })
      .catch(error => {
        dispatch(archiveHierarchyItemFailure(error));
      });
  };
// -----------------
// Restore resource actions
// -----------------
const startRestoreHierarchyItem = () => ({
  type: RESTORE_HIERARCHY_ITEM,
});

const restoreHierarchyItemFailure = error => ({
  type: RESTORE_HIERARCHY_ITEM_FAILURE,
  payload: error,
});

// action
const restoreHierarchyItemSuccess = hierarchyPath => ({
  type: RESTORE_HIERARCHY_ITEM_SUCCESS,
  payload: hierarchyPath,
});

export const restoreHierarchyItem =
  hierarchyPath =>
  (dispatch, getState, { dataCache }) => {
    dispatch(startRestoreHierarchyItem());
    const userEmailId = dataCache.get('currentUser')?.id;

    return ArchivesAPI.restoreHierarchyItem(hierarchyPath, userEmailId)
      .then(responseJson => {
        dispatch(restoreHierarchyItemSuccess(hierarchyPath));
        return responseJson;
      })
      .catch(error => {
        dispatch(restoreHierarchyItemFailure(error));
        throw error;
      });
  };

// -----------------------------------------------
// Delete actions
// -----------------------------------------------
const startDeleteHierarchyItem = () => ({
  type: DELETE_HIERARCHY_ITEM,
});

const deleteHierarchyItemFailure = error => ({
  type: DELETE_HIERARCHY_ITEM_FAILURE,
  payload: error,
});

// action
const deleteHierarchyItemSuccess = hierarchyPath => ({
  type: DELETE_HIERARCHY_ITEM_SUCCESS,
  payload: hierarchyPath,
});

export const deleteHierarchyItem =
  hierarchyPath =>
  (dispatch, getState, { dataCache }) => {
    dispatch(startDeleteHierarchyItem());
    const userEmailId = dataCache.get('currentUser')?.id;

    return ArchivesAPI.deleteHierarchyItem(hierarchyPath, userEmailId)
      .then(responseJson => {
        dispatch(deleteHierarchyItemSuccess(hierarchyPath));
        return responseJson;
      })
      .catch(error => {
        dispatch(deleteHierarchyItemFailure(error));
        throw error;
      });
  };
